import { Grid, LinearProgress, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse, handleErrorResponseAxios } from "../../_helpers/handleResponse.helper";
import { userInformationService } from "../../_services/userInformation.service";
import { accountService } from "../../_services/accounts.service";

export function UserProfileProfileImageManage() {

    const { userId } = useParams<{ userId: string }>();

    const [isLoading, setIsLoading] = useState(false);
    const [hasProfilePicture, setHasProfilePicture] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        if (accountService.isAdmin) {
            setIsLoading(false);
        }
        else {
            fetchUserImg(userId || "");
        }
    }, []);

    function updateProfilePicture(e: any) {
        e.preventDefault();
        var formData = new FormData();
        formData.append(`userId`, userId?.toString() || "");
        var fileInputField = document.getElementById("profileImg")
        formData.append("file", (fileInputField as any)?.files[0]);
        userInformationService.profileImageUpdate(formData)
            .then(
                () => { toastr.success("Image updated"); navigate(0) },
                (e) => { toastr.error("Invalid image"); }
            );
    }

    function fetchUserImg(id: string) {
        setIsLoading(true)
        return userInformationService
            .getProfileImage(id)
            .then(
                (json) => {
                    setHasProfilePicture(!!json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            {isLoading && <LinearProgress color="secondary" />}
            {(!isLoading && (!hasProfilePicture || accountService.isAdmin)) &&
                <Paper>
                    <ValidatorForm onError={() => { }} onSubmit={updateProfilePicture} noValidate>

                        <Grid container spacing={2} sx={{ mt: 0 }}>
                            <Grid item xs={12}>
                                <Typography variant="h6" textAlign="center">Profile Image Update</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="File"
                                    type="file"
                                    id="profileImg"
                                    fullWidth
                                    required
                                    helperText={"Image size cannot exceed 5MB"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <PrimaryButton
                                    type="button"
                                    variant="success"
                                    onClick={updateProfilePicture}>
                                    Update Profile Image
                                </PrimaryButton>
                            </Grid>
                        </Grid>
                    </ValidatorForm>
                </Paper >
            }

        </>
    );

}
